<template>
  <v-container>
<!--    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>-->
    <!-- Loading -->
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div class="mt-10 header bold text-tcdc-green text-uppercase">{{mainInfo[`name_${lang}`]}}</div>
    <v-row class="mt-3">
      <v-col>
        <youtube v-if="videoId"
                 :video-id="videoId"
                 ref="youtube"
                 :player-vars="playerVars"
                 width="100%"
                 height="500px">
        </youtube>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col>
          <div v-if="mainInfo" class="vhtml" v-html="mainInfo[`description_${lang}`]"></div>
        <span v-else class="sub-header1 grey--text">
          {{$t('about.description')}}
        </span>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col>
        <ImageCarousel />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex flex-1 align-center justify-space-between">
        <span class="text-tcdc-green header bold text-uppercase">tcdc bangkok</span>
        <div class="text-left text-tcdc-green d-flex align-center">
          <img src="../../assets/icons/sorts/resource_center.png" class="about-service-logo pr-2" />
          <img src="../../assets/icons/sorts/consult.png" class="about-service-logo pr-2" />
          <img src="../../assets/icons/sorts/venture_hire.png" class="about-service-logo pr-2" />
          <img src="../../assets/icons/sorts/membership.png" class="about-service-logo pr-2" />
        </div>
      </v-col>
    </v-row>
    <Divider />-->
    <v-row class="d-flex flex-wrap">
      <template v-for="(item, index) of aboutBranch">
        <v-col cols="12" :md="item.highlight ? 12 : 6" :key="index">
          <BranchCard
              :branchData="item"
              @onClick="eventDetailHandler(item)"
          />
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import BranchCard from "../../components/cards/BranchCard";
// import ImageCarousel from "../../components/carousels/ImageCarousel";
// import Divider from "../../components/dividers/Divider";
import Loading from 'vue-loading-overlay';
import { mapState } from 'vuex';
import { getIdFromUrl } from 'vue-youtube'
import {Utils} from "@/util/Utils";

export default {
  components: {
    BranchCard,
    Loading
    // ImageCarousel,
    // Divider
  },
    async mounted() {
        if (this.mainInfo.video_url) {
            // console.log(this.mainInfo.video_url)
            await this.getIdFromYoutube(this.mainInfo.video_url);
        }
    },
  created() {
    this.items[0].text = this.branchName;
    let params = { id: this.branchId, lang: this.lang };
      if (this.mainInfo && this.mainInfo.video_url) {
          // console.log(this.mainInfo.video_url)
          this.getIdFromYoutube(this.mainInfo.video_url);
      }
  },
  methods: {
    getIdFromYoutube(url){
      this.videoId = getIdFromUrl(url)
    },
    async eventDetailHandler(item) {
      this.isLoading = true;
      const template_id = item.template;
      // console.log(template_id);

      const dataParams = { branch_id: item.id, lang: this.lang };
      // change branch
      this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", dataParams)
      this.$store.dispatch("Branch/getBranchById", item.id)

      if (item.id === 5) {
        await this.$store.dispatch('Branch/getMiniByBranch', dataParams);
      }
      await this.$store.dispatch("About/getAboutAllMenu", dataParams);
      this.$store.dispatch("About/getAboutById",{
        id: item.id,
        lang: this.lang
      }).then(async res => {
        if (res.response_code == 200) {
          //set about data in form
          await this.$store.dispatch("About/setFormAbout", res.result);
          this.isLoading = false;
          const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
          if (template_id === 3) {
            return this.$router.push(`/${this.lang}`+`${branch}/about/mini-tcdc`);
          } else {
            return this.$router.push(`/${this.lang}`+`${branch}/about`);
          }
        } else {
          alert('data not found');
          this.isLoading = false;
        }
      })
    },
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      branchId: state => state.Branch.branch_id,
      allBranches: state => state.Branch.branches,
      lang: state => state.Branch.lang,
        mainInfo: state => state.About.about_main,
      aboutBranch : state=>{
        let mini = state.About.about.find(item => !!item.branch && item.branch.branch_id === 5);
          let exceptMini = state.About.about.filter(item => !!item.branch && item.branch.branch_id !== 5);
          let sorted = [
              ...exceptMini,
              mini
          ]
        return [
          ...sorted.map(about=>({
            id: about.branch_id,
            name: about.branch ? about.branch.branch_name : '',
            img : about.slide_images.length > 0 ? about.slide_images[0].image : '',
            template : about.template,
            time: "",
            tag: about.branch.tag_name,
            place: about.branch ? about.branch.branch_name : '',
            highlight: about.orders === 1 ? true : false,
            membership: about.branch.membership && about.branch.membership.length > 0 ? about.branch.membership : (about.membership_all ? about.membership_all : []),
            venue_hire: about.branch.venue_hire
          }))
        ]
      }
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        href: "/home"
      },
      {
        text: "ABOUT",
        disabled: true,
      }
    ],
    events : [],
    isLoading: false,
    videoId: 'jXyhD4ZLbQA',
    playerVars: {
      autoplay: 1
    },
    visibleFull: false,
    seeBigger: false,
  })
};
</script>

<style scoped lang="scss">
.about-service-logo {
  height: 25px;
  object-fit: contain;
}
.grey--text {
  font-family: Sarabun;
  color: $tcdc16;
}
</style>
